import { defineStore } from "pinia";
import { ref } from "vue";

export const useAuthStore = defineStore(
    "auth",
    () => {
        const token = ref();
        const accessToken = ref();
        const email = ref();

        return {
            token,
            accessToken,
            email
        };
    },
    /**
     *    To keep authorisation data, like the JWT alive,
     *    persist this specific store.
     */
    {
        persist: true,
    },
);
